module.exports = __webpack_public_path__ + "static/media/close.026bd35e.svg";